<template>
  <div class="wlx-site-px-wrapper">
    <div v-if="!IsShowStuLIst">
      <header class="u-school-manager-head">
        <el-form :inline="true" size="small" class="site-lec-form">
          <el-form-item>
            <el-input v-model="sTitle" placeholder="请输入培训标题" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add">添加</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-delete" @click="deleteAll">删除</el-button>
          </el-form-item>
        </el-form>
        <!-- 新增培训 -->
        <el-dialog
          title="新增培训"
          :visible.sync="addNewNoticeVisible"
          :before-close="cancel"
          :append-to-body="true"
          width="50%"
          :close-on-click-modal="false"
        >
          <div>
            <el-form ref="ruleForm" label-width="160px">
              <el-form-item label="标题" prop="title">
                <el-input v-model="title"></el-input>
              </el-form-item>
              <el-form-item label="开始时间">
                <el-date-picker v-model="pulishTime" type="datetime" placeholder="选择日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间">
                <el-date-picker v-model="endTime" type="datetime" placeholder="选择日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="节点内容">
                <Editor v-model="content" placeholder="请输入内容"/>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="addSchoolAttestation()">确 定</el-button>
          </span>
        </el-dialog>
        <!--编辑-->
        <el-dialog
          title="编辑培训"
          :visible.sync="editNoticeVisible"
          :before-close="cancel"
          :append-to-body="true"
          width="50%"
          :close-on-click-modal="false"
        >
          <div>
            <el-form ref="ruleForm" label-width="160px">
              <el-form-item label="标题" prop="title">
                <el-input v-model="title"></el-input>
              </el-form-item>
              <el-form-item label="序号" prop="orderNumber">
                <el-input v-model="orderNumber"></el-input>
              </el-form-item>
              <el-form-item label="开始时间">
                <el-date-picker v-model="pulishTime" type="datetime" placeholder="选择日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间">
                <el-date-picker v-model="endTime" type="datetime" placeholder="选择日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="节点内容">
                <Editor v-model="content" placeholder="请输入内容"/>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="editAttestation()">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog           
          title="审核不通过原因"
          :visible.sync="noAuditVisible"
          :before-close="cancel"
          :append-to-body="true"
          width="50%"
          :close-on-click-modal="false">
            <p v-html="noAuditReason"></p>
        </el-dialog>
      </header>
      <div class="u-table-main">
        <el-table
          ref="multipleeeeTable"
          :data="list"
          style="width: 100%;"
          @selection-change="handleSelectionChange"
        >
          <el-table-column prop="id" type="selection" width="55"></el-table-column>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="title" label="培训标题"></el-table-column>
          <el-table-column prop="dateCreated" label="创建时间"></el-table-column>
          <el-table-column prop="contentText" label="培训内容"></el-table-column>
          <el-table-column prop="pulishTime" label="开始时间"></el-table-column>
          <el-table-column prop="endTime" label="结束时间"></el-table-column>
          <el-table-column prop="IsAudit" label="审核状态">
            <template slot-scope="scope">
              <span style="color: #05C94F" v-if="scope.row.IsAudit==1">审核通过</span>
              <span style="color: #E53939" v-if="scope.row.IsAudit==2">审核不通过</span>
              <span style="color: #2D82FF" v-if="scope.row.IsAudit==0">待审核</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="el-icon-view"
                @click="getStuist(scope.row.id)"
                type="primary"
                title="报考情况"
                v-if="scope.row.IsAudit ==1"
              ></el-button>
              <el-button
                size="mini"
                class="el-icon-view"
                @click="getNoAuditStuist(scope.row.ReasonRejection)"
                type="primary"
                title="报考情况"
                v-if="scope.row.IsAudit ==2"
              ></el-button>
              <el-button
                size="mini"
                class="el-icon-edit"
                @click="edit(scope.row)"
                type="primary"
                title="编辑"
              ></el-button>
              <el-button
                size="mini"
                type="danger"
                class="el-icon-delete"
                @click="deleteMajor(scope.row.id)"
                titlt="删除"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="u-page-con">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="pageIndex"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          v-show="total>0"
        ></el-pagination>
      </div>
    </div>
    <!-- <enrollStuList v-if="IsShowStuLIst" :attestationId="attestationId" v-on:close="close"></enrollStuList> -->
  </div>
</template>

<script>
import NewThumbnail from "../../component/AliyunOSS/NewThumbnail.vue";
import enrollStuList from "page/xSchool/siteManager/enrollStuList.vue";
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      addNewNoticeVisible: false,
      editNoticeVisible: false,
      /* -----------添加/修改弹框参数------------ */
      sTitle: "",
      title: "",
      content: "",
      urlAliyunOSS: "/api/design/osssign/getsign",
      introduceNodeId: "",
      pulishTime: "",
      endTime:"",
      orderNumber: 0,
      /* --------------------------------------- */
      id: "",
      attestationIds: [],
      noDataShow: false,
      loadingShow: false,
      noAuditVisible: false,
      //介绍节点栏目
      columnList: [],
      school: null,
      hnSchoolId: "hnzjc",
      value: "",
      IsShowStuLIst: false,
      attestationId: "",
      noAuditReason:'',
      IsAudit:1,
    };
  },
  components: {
    NewThumbnail,
    enrollStuList
  },
  created() {
    this.getAttestationList(0);
  },
  methods: {
    getAttestationList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/Attestation/getAttestationList", {
          title: this.sTitle,
          page: page,
          pageSize: this.pageSize,
          type: 3
        })
        .then(rst => {
          if (rst.code == 1) {
            that.list = rst.list;
            that.total = rst.pagination.totalCount;
            that.pageSize = rst.pagination.pageSize;
            that.pageIndex = rst.pagination.pageIndex;
            that.cancel();
          }
        });
    },
    onPageChangeHandler(page) {
      this.getAttestationList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getAttestationList(1);
    },
    handleSelectionChange(val) {
      this.attestationIds = [];
      val.forEach(element => {
        this.attestationIds.push(element.id);
      });
    },
    cancel() {
      this.addNewNoticeVisible = false;
      this.editNoticeVisible = false;
      this.noAuditVisible = false;
      this.title = "";
      this.content = "";
      this.attestationIds = [];
      this.pulishTime = "";
      this.endTime = "";
    },
    addSchoolAttestation() {
      var that = this;
      this.$http
        .post("/api/XOrg/Attestation/addAttestation", {
          Title: this.title,
          pulishTime: this.pulishTime,
          endTime: this.endTime,
          Content: this.content,
          type: 3
        })
        .then(rst => {
          if (rst.code == 1) {
            this.cancel();
            this.$message.success(rst.msg);
            this.getAttestationList();
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    add() {
      this.addNewNoticeVisible = true;
    },
    //获取审核不通过原因
    getNoAuditStuist(reason){
      this.noAuditReason = reason;
      this.noAuditVisible = true;
    }, 
    editAttestation() {
      var that = this;
      this.$http
        .post("/api/XOrg/Attestation/editAttestation", {
          Title: this.title,
          pulishTime: this.pulishTime,
          endTime: this.endTime,
          content: this.content,
          orderNumber: this.orderNumber
        })
        .then(rst => {
          if (rst.code == 1) {
            this.cancel();
            this.$message.success(rst.msg);
            this.getAttestationList();
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    edit(row) {
      this.editNoticeVisible = true;
      this.title = row.title;
      this.content = row.content;
      this.pulishTime = row.pulishTime;
      this.endTime = row.endTime;
      this.orderNumber = row.orderNumber;
    },
    deleteMajor(id) {
      this.attestationIds.push(id);
      this.$confirm("此操作将删除该介绍节点, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteFun();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    search() {
      this.getAttestationList(1);
    },
    deleteAll() {
      if (this.attestationIds.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择培训",
          type: "warning"
        });
        return false;
      }
      this.$confirm("此操作将删除所选培训, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteFun();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    deleteFun() {
      var that = this;
      this.$http
        .post("/api/XOrg/Attestation/deleteAttestation", {
          attestationIds: this.attestationIds
        })
        .then(rst => {
          if (rst.code == 1) {
            that.$message.success(rst.msg);
            that.getAttestationList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    getStuist(id) {
      this.attestationId = id;
      this.$router.push({
        name:'siteTrainDetail',
        params:{
          attestationId:id
        }
      });
    },
    close() {
      this.attestationId = "";
      this.IsShowStuLIst = false;
    }
  }
};
</script>

<style lang="scss">
.wlx-site-px-wrapper {
  .site-lec-form {
    margin: 13px 62px 0 0;
  }
}
</style>

